import React, {useState} from 'react';
import styles from './FaqAccordion.module.css';
import { useTranslation } from 'react-i18next';

type FaqItem = { question: string; answer: string };

const FaqAccordion: React.FC = ()  => {
    const { t } = useTranslation();

    const items = t('faq.questions', { returnObjects: true }) as FaqItem[];

     const [openIndex, setOpenIndex] = useState<Set<number>>(new Set());

    const toggle = (idx: number) => {
        setOpenIndex(prev => {
            const next = new Set(prev);
            next.has(idx) ? next.delete(idx) : next.add(idx);
            return next;
        });
    };

    return (
        <section className={styles['faqAccordion-section']}>
            <ul className={styles['faq-list']}>
                {items.map((item, i) => {
                    const isOpen = openIndex.has(i);
                 return (
                    <li key={i} className={styles['faq-item']}>
                        <button  className={`${styles['faq-question']} ${isOpen ? styles.active : ''}`} onClick={() => toggle(i)} aria-expanded={isOpen}>
                            {item.question}
                         </button>
                        <div className={`${styles['faq-answer']} ${isOpen ? styles.open : ''}`}>
                            <p>{item.answer}</p>
                        </div>
                    </li>
                 );
            })}
            </ul>
        </section>
    );
};

export default FaqAccordion;